import { render } from "./follow_button.vue?vue&type=template&id=6a0717e7"
import script from "./follow_button.js?vue&type=script&lang=js"
export * from "./follow_button.js?vue&type=script&lang=js"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__